<template>
  <div class="set" style="background-color:#f1f5f8; padding: 20px;">
    <!-- 顶部导航 -->
    <van-nav-bar
      title="我的合同"
      v-if="token.length <= 0"
      @click-left="onClickLeft"
      left-arrow
    ></van-nav-bar>
    <div v-if="token.length <= 0" style="height: 29px;"></div>

    <!-- 合同图片显示 -->
    <div class="contract-img-box">
      <img
        v-if="contract_img"
        :src="contract_img"
        style="width:100%; display:block; margin:0 auto;"
        alt="合同"
      />
    </div>
  </div>
</template>

<script>
import request from "@utils/request";
import { goodsImage } from "@utils/goodsImage";

export default {
  data() {
    return {
      token: "",
      contract_img: ""
    };
  },
  created() {
    // 获取 token
    if (this.$route.query.token) {
      this.token = this.$route.query.token;
      this.$store.commit("Token", this.token);
    }

    this.loadContract();
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    async loadContract() {
      const id = this.$route.query.id;
      request
        .get("/fund/hetong/index", { id: id }, { login: false })
        .then(res => {
          // 直接获取合同图片路径
          if (res.data.user_project && res.data.user_project.contract_img) {
            this.contract_img = goodsImage(res.data.user_project.contract_img);
          }
        })
        .catch(err => {
          console.error("合同获取失败", err);
        });
    }
  }
};
</script>
<style scoped lang="less">
.img1 {
  position: absolute;
  bottom: 1.5%;
  left: 8.5%;
}
.img2 {
  position: absolute;
  bottom: 7%;
  right: 17%;
}
.teamindeximg {
  width: 100%;
}

.teamtitle {
  background-color: #f1f5f8;
  font-size: 15px;
  display: flex;
  padding: 10px;
  box-sizing: border-box;
  align-items: center;
  width: calc(100% - 12px);
}

.teamnum {
  background-color: #ff1900;
  color: #fff;
  padding: 0 8px;
  border-radius: 20px;
  margin-left: 3px;
  font-size: 13px;
  height: 18px;
  line-height: 20px;
}

.teamli {
  border-bottom: 1px solid #f6f6f6;
  padding: 7px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;

  font-size: 15px;
}

.teamlist {
  padding-right: 12px;
}

.teamlil {
  display: flex;
  align-items: center;
}

.teamlil img {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 100%;
  margin-right: 20px;
}
/deep/ .van-nav-bar .van-icon {
  color: #333;
}

/deep/ #all {
  width: 780px;
  padding: 100px 32px;
  background: #fff;
}
</style>
